/**
 * Enum nhóm chân chữ ký
 * pdtai 24.04.2024
 * Ae cần thêm thì bổ sung tiếp
 */
export default {
    // Nhóm 1
    One: 1,
    // Nhóm2
    Two: 2
};
